
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'alpButton',
  setup: function(props, content){
    console.log('alpButton', props, content)
  }
});
